/*
 * Google Analytics based on react-ga
 * https://www.npmjs.com/package/react-ga
 */
import ReactGA from 'react-ga';

if (!window._GA_ENV) window._GA_ENV = {};

class Analytics {
    constructor() {
        this.Config = Object.assign({
            options: {
                debug: false,
            },
        }, ENVConfig.GA_TRACKING || {});

        ['set', 'event', 'exception', 'timing'].forEach((type) => {
            this[type] = (args) => ReactGA[type].call(this, { transport: 'beacon', ...args })
        });

        this.ga = window._GA_ENV.ga = ReactGA.ga;
    }

    defaults(page, options = {}) {
        this.set({
            page,
            location: window.location.origin,
            ...options,
        });

        return this;
    }

    page(page, options = {}) {
        this.defaults(page, options);
        ReactGA.pageview(page);

        return this;
    }

    modal(page, options = {}) {
        this.defaults(page, options);
        ReactGA.modalview(page);

        return this;
    }

    init() {
        if (!this.Config.enabled) return this;

        if (!window._GA_ENV.init) {
            window._GA_ENV.init = true;
            ReactGA.initialize(this.Config.id, {
                ...this.Config.options,
            });
        }

        return this;
    }
}

const _Analytics = new Analytics().init();
export default _Analytics;
